import classNames from 'classnames';
import React from 'react';
import './index.scss';
import EfLink from '../ef-link';
import EFArrowRight from 'elem/ui-assets/icons/common/EFArrowRight';

interface EfInfoSectionProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * theme
     */
    theme?: 'black' | 'white';
    /**
     * label标签
     */
    label?: string;
    /**
     * title
     */
    title: string;
    /**
     * subtitle
     */
    subtitle?: string;
    /**
     * desc
     */
    desc?: string;
    /**
     * link文本
     */
    linkText?: string;
    /**
     * link链接url
     */
    linkUrl?: string;
}

/**
 * 维护: kalkin
 *
 * 文本段落： label(可选)， title， subtitle(可选)， desc（可选）等组成的文本段落
 */
const EfInfoSection: React.FC<EfInfoSectionProps> = ({ className, theme = 'black', icon, label, title, subtitle, desc, linkText, linkUrl }) => {
    const prefixCls = `ef-info-section`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
    });

    return (
        <div className={classes}>
            {label && <p className={`${prefixCls}-label`}>{label}</p>}
            <p className={`${prefixCls}-title`}>{title}</p>
            {subtitle && <p className={`${prefixCls}-subtitle`}>{subtitle}</p>}
            {desc && <p className={`${prefixCls}-desc`}>{desc}</p>}
            {linkText && linkUrl && (
                <>
                    {linkUrl === ' ' ? (
                        <div className={`${prefixCls}-link ${prefixCls}-link-disable`}>
                            <span className={`${prefixCls}-link-text`}>{linkText}</span>
                            <EFArrowRight />
                        </div>
                    ) : (
                        <EfLink href={linkUrl} className={`${prefixCls}-link`}>
                            <span className={`${prefixCls}-link-text`}>{linkText}</span>
                            <EFArrowRight />
                        </EfLink>
                    )}
                </>
            )}
        </div>
    );
};

export default EfInfoSection;
